




















































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import { TermsTab } from "@/shared/types";
import { BankCustodian } from "@/admin/types";
import Tab from "@/shared/components/ui/Tab.vue";
import TabGroup from "@/shared/components/ui/TabGroup.vue";
import TermsFeeSchedule from "@/employee/components/onboarding/TermsFeeSchedule.vue";
import AvidiaTermsFeeSchedule from "@/employee/components/onboarding/AvidiaTermsFeeSchedule.vue";
import AllegacyTermsFeeSchedule from "@/employee/components/onboarding/AllegacyTermsFeeSchedule.vue";
import * as RouteNames from "@/employee/route-names";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useEnrollmentStore } from "@/employee/store/enrollment";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { useUserStore } from "@/shared/store/user";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";

@Component({
  components: {
    Tab,
    TabGroup,
    TermsFeeSchedule,
    AvidiaTermsFeeSchedule,
    AllegacyTermsFeeSchedule
  }
})
export default class TermsAndConditions extends Vue {
  custodianSettingsStore = useCustodianSettingsStore();
  entrollmentStore = useEnrollmentStore();
  portalStore = usePortalCustomizationStore();
  userStore = useUserStore();
  featureFlagStore = useFeatureFlagStore();


  readonly bendTermsAndConditionsFile = "bend_financial_terms_of_service 20181009.pdf";

  isSubmitting = false;
  isLoaded = true;
  agreedToESignTerms = false;
  agreedToTerms = false;
  TermsTab = TermsTab;
  activeTab = TermsTab.Bank;

  mounted () {
    this.entrollmentStore.loadFeeWaiverSettings(this.portalStore.partnerId);
    this.$on("tab-clicked", (event, tab) => {
      event.preventDefault();
      this.handleTabChange(tab.type);
    });
  }

  handleTabChange (tabType) {
    this.activeTab = tabType;
  }

  get termsAndConditionsHref () {
    return `/${this.bendTermsAndConditionsFile}`;
  }

  get bendTermsSource () {
    if (this.activeTab === TermsTab.FeeSchedule) {
      return this.$router.resolve({ name: RouteNames.FeeSchedulePrint }).href;
    }

    if (this.activeTab === TermsTab.Bank) {
      return this.custodianSettingsStore.termsUrl;
    } else {
      return this.termsAndConditionsHref;
    }
  }

  get showAllegacyDynamicFees (): boolean {
    return this.custodianSettingsStore.userCustodian === BankCustodian.Allegacy &&
        this.featureFlagStore.featureFlagsAvailable && this.featureFlagStore.flags.showDynamicAllegacyFees;
  }
}

